import classNames from 'classnames/bind';
import { isEqual } from 'lodash';
import { DropdownMenu, FormField } from 'taboola-ultimate-ui';
import { withIndication } from 'modules/errors/components';
import { useFieldTypes } from 'modules/push-api/hooks/useFieldTypes';
import { useFieldWithKey } from 'modules/push-api/hooks/useFieldWithKey';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './fieldNameDropdown.module.scss';

const FormFieldWithIndication = withIndication(FormField);
const formFieldId = 'field-selector';
const classNameBuilder = classNames.bind(styles);

export const FieldNameDropdown = ({ fieldIndex, entityIndex, filterIndex, disabled = false, isNewFilter = false }) => {
    const { value: entityType } = useFormFieldValue({
        field: `entities.${entityIndex}.type`,
        isAbsolute: true,
    });

    const { field, setFieldOnChange } = useFieldWithKey(entityIndex, fieldIndex);
    const { data: fieldTypes, isLoading } = useFieldTypes(entityType);

    const getDisabledStatus = !isEqual(filterIndex, 0) || disabled;

    const selectedValue = { value: field || '' };

    return (
        <FormFieldWithIndication
            inputId={formFieldId}
            containerClass={styles['field-container']}
            label={<FormattedMessage id="push.api.create.settings.field.label" defaultMessage="Field" />}
            labelClass={classNameBuilder({ 'label-new': isNewFilter, label: !isNewFilter })}
        >
            <div className={styles['field']}>
                {!isNewFilter && (
                    <span className={styles['field-icon']}>
                        <FormattedMessage id="push.api.create.settings.field.icon" defaultMessage="If" />
                    </span>
                )}

                <DropdownMenu
                    required
                    id={formFieldId}
                    selectedValueObject={selectedValue}
                    options={fieldTypes}
                    onChange={setFieldOnChange}
                    disabled={getDisabledStatus}
                    searchable
                    aria-label="field-dropdown"
                    className={styles['dropdown-menu']}
                    isLoading={isLoading}
                    key={entityType}
                />
            </div>
        </FormFieldWithIndication>
    );
};
